import { Component, Input, Output, EventEmitter, OnInit, ViewContainerRef,
    ViewChildren, QueryList } from '@angular/core';

import { HisUiService, HisAuthService } from 'hisng';

import { DYNAMIC_FIELD_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';

import { ResearchInfrastructureEmployment } from 'app/fs/res/research-infrastructure/model/research-infrastructure-classes';

@Component( {
    selector: 'res-research-infrastructure-employments',
    templateUrl: './research-infrastructure-employments.component.html',
    providers: [ProviderManager.getComponentProvider(ResearchInfrastructureEmploymentsComponent)],
} )
export class ResearchInfrastructureEmploymentsComponent implements OnInit {
    @Input() researchInfrastructureEmployments: ResearchInfrastructureEmployment[];
    @Output() researchInfrastructureEmploymentsChange: EventEmitter<ResearchInfrastructureEmployment[]> = new EventEmitter();
    @ViewChildren( DYNAMIC_FIELD_ANCHOR, { read: ViewContainerRef } ) fieldViewContainerList: QueryList<ViewContainerRef>;

    public dateFormat: string;

    public researchInfrastructureEmployment: ResearchInfrastructureEmployment;
    public visibility = false;
    public editIndexToRemember: number;

    constructor( public auth: HisAuthService,
        private hisUiService: HisUiService ) {
    }

    ngOnInit() {
        // get dateFormat depending on locale
        this.dateFormat = this.hisUiService.translate( 'common.dateFormat' );
    }

    public addResearchInfrastructureEmployment() {
        this.editIndexToRemember = null;
        this.researchInfrastructureEmployment = null;
        this.visibility = true;
    }

    public editResearchInfrastructureEmployment( riEmplyment: ResearchInfrastructureEmployment, index: number ) {
        this.editIndexToRemember = index;
        this.researchInfrastructureEmployment = JSON.parse( JSON.stringify( riEmplyment ) );
        this.researchInfrastructureEmployment.validTo = this.researchInfrastructureEmployment.validTo
            ? new Date(this.researchInfrastructureEmployment.validTo) : null;
        this.researchInfrastructureEmployment.validFrom = this.researchInfrastructureEmployment.validFrom
            ? new Date(this.researchInfrastructureEmployment.validFrom) : null;
        this.visibility = true;
    }

    public deleteResearchInfrastructureEmployment( riEmployment: ResearchInfrastructureEmployment ) {
        this.researchInfrastructureEmployments = this.researchInfrastructureEmployments.filter( emp => emp !== riEmployment );
        this.researchInfrastructureEmploymentsChange.emit( this.researchInfrastructureEmployments );
    }

    public saveResearchInfrastructureEmploymentChange( event: any ) {
        if( this.editIndexToRemember == null ) {
            this.researchInfrastructureEmployments.push( event );
        } else {
            this.researchInfrastructureEmployments[this.editIndexToRemember] = event;
            this.editIndexToRemember = null;
        }
    }
}
